
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Link from 'components/Link'

export default class Button extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    color: PropTypes.oneOf(['default', 'transparent', 'blue', 'red', 'gray', 'green', 'round_blue', 'round_green']),
    disabled: PropTypes.bool,
    border: PropTypes.bool,
    to: PropTypes.string
  }

  static defaultProps = {
    color: 'default'
  }

  render() {
    const {color, disabled, border, to, ...rest} = this.props
    const className = classnames(
      'button',
      {
        [`is-${color}`]: color,
        'is-disabled': disabled,
        'no-borders': border === false
      },
      this.props.className
    )
    if (to) {
      return <Link to={to} {...rest} className={className} />
    } else {
      return <button {...rest} className={className} disabled={disabled} />
    }
  }
}



// WEBPACK FOOTER //
// ./client/components/Button/index.js